import api from './axiosConfig';
import { handleApiError } from './errorHandler';

export const amazonAPI = {
    accounts: {
        getAll: async () => {
            try {
                const { data } = await api.get('/api/amazon/accounts/');
                return data;
            } catch (error) {
                handleApiError(error, 'Get all Amazon accounts error:');
            }
        },
        getById: async (id) => {
            try {
                const { data } = await api.get(`/api/amazon/accounts/${id}/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Get Amazon account error:');
            }
        },
        create: async (accountData) => {
            try {
                const { data } = await api.post('/api/amazon/accounts/create/', accountData);
                return data;
            } catch (error) {
                handleApiError(error, 'Create Amazon account error:');
            }
        },
        update: async (id, accountData) => {
            try {
                const { data } = await api.put(`/api/amazon/accounts/${id}/update/`, accountData);
                return data;
            } catch (error) {
                handleApiError(error, 'Update Amazon account error:');
            }
        },
        delete: async (id) => {
            try {
                const { data } = await api.delete(`/api/amazon/accounts/${id}/delete/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Delete Amazon account error:');
            }
        },
        testConnection: async (id) => {
            try {
                const { data } = await api.post(`/api/amazon/accounts/${id}/test-connection/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Test Amazon connection error:');
            }
        }
    },
    queries: {
        getAll: async (accountId) => {
            try {
                const params = accountId ? `?account_id=${accountId}` : '';
                const { data } = await api.get(`/api/amazon/queries/${params}`);
                return data;
            } catch (error) {
                handleApiError(error, 'Get Data Kiosk queries error:');
            }
        },
        submit: async (accountPk, requestData) => {
            try {
                const { data } = await api.post(`/api/amazon/accounts/${accountPk}/queries/submit/`, requestData);
                return data;
            } catch (error) {
                handleApiError(error, 'Submit Data Kiosk query error:');
            }
        },
        retry: async (id) => {
            try {
                const { data } = await api.post(`/api/amazon/queries/${id}/retry/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Retry Data Kiosk query error:');
            }
        },
        delete: async (id) => {
            try {
                const { data } = await api.delete(`/api/amazon/queries/${id}/delete/`);
                return data;
            } catch (error) {
                handleApiError(error, 'Delete Data Kiosk query error:');
            }
        }
    },
    economics: {
        getAll: async (params) => {
            try {
                const query = new URLSearchParams(params).toString();
                const { data } = await api.get(`/api/amazon/economics/?${query}`);
                return data;
            } catch (error) {
                handleApiError(error, 'Get Amazon economics error:');
            }
        },
        getSummary: async (params) => {
            try {
                const query = new URLSearchParams(params).toString();
                const { data } = await api.get(`/api/amazon/economics/summary/?${query}`);
                return data;
            } catch (error) {
                handleApiError(error, 'Get Amazon economics summary error:');
            }
        },
        export: async (params, format = 'csv') => {
            try {
                const response = await api.get('/api/amazon/economics/export/', {
                    params: { ...params, file_format: format },
                    responseType: 'blob',
                });

                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;

                const timestamp = new Date().toISOString()
                    .replace(/[:\-T]/g, '')
                    .slice(0, 14);
                const fileName = `amazon_economics_${timestamp}.${format === 'excel' ? 'xlsx' : 'csv'}`;
                link.setAttribute('download', fileName);

                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
                window.URL.revokeObjectURL(url);

                return true;
            } catch (error) {
                if (error.response?.data instanceof Blob) {
                    const text = await error.response.data.text();
                    try {
                        const json = JSON.parse(text);
                        throw new Error(json.error || json.detail || 'Export failed');
                    } catch {
                        throw new Error(text || 'Export failed');
                    }
                }
                handleApiError(error, 'Export Amazon economics error:');
                return false;
            }
        }
    }
};
